import { createContext, useContext, useMemo, useState } from "react";

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [bookingTier, setBookingTier] = useState(null);

  const addItem = (flavor, size, unit) => {
    const key = `${flavor.id}-${size}`;
    setCart((c) => {
      const ex = c.find((i) => i.key === key);
      if (ex) return c.map((i) => (i.key === key ? { ...i, qty: i.qty + 1 } : i));
      return [...c, { key, id: flavor.id, name: flavor.name, size, unit, qty: 1, color: flavor.color }];
    });
  };

  const setQty = (key, qty) => {
    if (qty <= 0) {
      setCart((c) => c.filter((i) => i.key !== key));
    } else {
      setCart((c) => c.map((i) => (i.key === key ? { ...i, qty } : i)));
    }
  };

  const removeItem = (key) => setCart((c) => c.filter((i) => i.key !== key));
  const clearCart = () => setCart([]);

  const cartTotal = useMemo(() => cart.reduce((s, i) => s + i.unit * i.qty, 0), [cart]);
  const cartCount = useMemo(() => cart.reduce((s, i) => s + i.qty, 0), [cart]);

  const value = {
    cart, addItem, setQty, removeItem, clearCart,
    cartOpen, setCartOpen,
    bookingTier, setBookingTier,
    cartTotal, cartCount,
  };
  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}

export function useStore() {
  return useContext(StoreContext);
}
